<template>
  <div class="content">
    <div class="line_bac"></div>
    <div class="header">
      <i class="el-icon-date"></i>
      <span class="title">提报记录查询</span>
    </div>
    <!-- <div class="operate">
      <el-button class="add" @click="addBadge">新增</el-button>
      <el-button class="add" @click="editBadge">修改</el-button>
      <el-button type="danger" @click="deleteBadge">删除</el-button>
    </div> -->
    <div class="query_con">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="">
          <el-date-picker
            v-model="medalDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 260px"
            @change="queryData"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发布状态">
          <el-select
            v-model="query.taskStatus"
            placeholder="请选择发布状态"
            style="width: 200px"
            clearable
            @change="queryData"
          >
            <el-option
              v-for="item in optionsBadgeType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button class="add" @click="queryData">查询</el-button>
          <el-button class="add" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="windowHeight"
      >
        <el-table-column label="序号" type="index" width="55" align="center">
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="nominee"
          label="提名人姓名"
          align="center"
          min-width="90"
        >
        </el-table-column>
        <el-table-column
          prop="empNo"
          label="提名人工号"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="nominType"
          label="提名类型"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="nominated"
          label="被提名人/团队"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="nominStandard"
          label="提名标准"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="achievement"
          label="主要成果"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="deedRemark"
          label="事迹概述"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="recommendation"
          label="提名人推荐语"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="reviewStartTime"
          label="开始时间"
          align="center"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="reviewEndTime"
          label="结束时间"
          align="center"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="taskStatusName"
          label="发布状态"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import moment from "moment";
export default {
  name: "badgeCategory",
  data() {
    return {
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      multipleSelection: [],
      tableLoading: false,
      windowHeight: 350,
      query: {
        taskStatus: "",
        startTime: "",
        endTime: ""
      },
      medalDate: [],
      optionsBadgeType: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "1",
          label: "已发布"
        },
        {
          value: "2",
          label: "已过期"
        },
        {
          value: "0",
          label: "未发布"
        }
      ],
      optionNominate: []
    };
  },
  created() {
    this.queryByNominType();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 300;
      });
    },
    //每页显示条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    //当前页数
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.queryData();
    },
    //提名标准
    queryByNominType() {
      api.queryByType({ type: "nominStandard" }).then(res => {
        if (res.code == 200) {
          this.optionNominate = res.data;
        }
      });
    },
    // // 查询 权限
    // queryAuth() {
    //   this.tableLoading = true;
    //   api
    //     .queryMedalUserPermission({ name: this.$store.state.userInfo.username })
    //     .then(res => {
    //       if (res.code == 200) {
    //         this.queryData(res.data.list[0]);
    //       }
    //     });
    // },
    // 查询 列表
    queryData() {
      this.tableLoading = true;
      const json = {
        ...this.pageData,
        taskStatus: this.query.taskStatus,
        startTime:
          this.medalDate?.length > 0
            ? moment(this.medalDate[0]).format("YYYY-MM-DD")
            : "",
        endTime:
          this.medalDate?.length > 0
            ? moment(this.medalDate[1]).format("YYYY-MM-DD")
            : "",
        username: this.$store.state.userInfo.username
      };
      api
        .queryMedalTaskList(json)
        .then(res => {
          if (res.code == 200) {
            this.total = res.data.total;
            this.tableData = res.data.list;
            this.tableData = this.tableData.map(item => {
              item.createTime = item.createTime
                ? moment(item.createTime).format("YYYY-MM-DD")
                : "";
              // item.nominStandardValue = this.optionNominate.filter(
              //   item1 => item1.id == item.nominStandard
              // )[0].value;

              return item;
            });
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    //导出
    handleExport() {
      const json = {
        ...this.pageData,
        taskStatus: this.query.taskStatus,
        startTime:
          this.medalDate?.length > 0
            ? moment(this.medalDate[0]).format("YYYY-MM-DD")
            : "",
        endTime:
          this.medalDate?.length > 0
            ? moment(this.medalDate[1]).format("YYYY-MM-DD")
            : "",
        username: this.$store.state.userInfo.username
      };
      api.excelBadgeReport(json).then(res => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `勋章提报.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #f2fcf9;
  height: 100%;
  .line_bac {
    width: 100%;
    height: 20px;
    // background-color: #00ada7;
  }
  .header {
    width: 100%;
    height: 90px;
    line-height: 90px;
    background-color: #efefef;
    border-bottom: 4px solid #d0d1d1;
    font-size: 29px;
    ::v-deep {
      .el-icon-date {
        color: #00ada7;
        margin: 0 10px 0 40px;
      }
    }
    .title {
      color: #00ada7;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 0px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
}
</style>
